<template>
  <Navbar :whitetheme="whitetheme" navbaron="meetingmanagement"/>
  <InputCode :listCategory="listCategory"/>
  <ScrollToTop />
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import InputCode from '@/components/ComponentMeetingManagement/InputCode.vue';
import ScrollToTop from '@/components/ScrollToTop.vue';
import axios from 'axios';

export default {
  data(){
    return{
      whitetheme: true,
      listCategory: []
    }
  },
  components:{
    Navbar,
    InputCode,
    ScrollToTop,
  },
  created(){
    axios.get(`team`)
    .then(res => {
      this.listCategory = res.data;
    }).catch(err => {
      console.log(err.message);
    })
  },
  methods:{
    scrollup(){
        window.scroll({
            top: 0,
            left: 0,
        })
    },
  },
  mounted(){
      this.scrollup()
  }
}
</script>